import { useBreakpoints } from '@vueuse/core'

export const useViewport = () => {
  const breakpoints = useBreakpoints({
    mobile: 0,
    tablet: 640,
    desktop: 1024,
  })

  const isDesktop = breakpoints.greater('tablet')

  return {
    breakpoints,
    isDesktop,
  }
}
